import * as storeHelper from '@/store/store.helper';
import { NavBarInterface, NAVBAR_SIDE_ICON } from '@/store/types';
import { Component, Vue, Provide, Prop, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { SectionInterface, MiniUserInterface, ParentSectionInterface, DocumentInterface, VotesInterface, uid } from '@/types/interfaces';
import coloredSvg from '@/components/colored.svg/colored.svg.vue';
import * as enums from '@/types/enums';
import quillEditor from '@/components/quill.editor/quill.editor.vue';
import route from 'vue-router';
import {DocumentsModule, SectionsModule, UsersModule} from "@/store/store.helper";
import draggable from 'vuedraggable';
import {SECTION_STATUS} from "@/types/enums";

@Component({
  components: {
    'colored-svg': coloredSvg,
    quillEditor,
    draggable
  }
})
export default class DocumentDraft extends Vue {
  @storeHelper.DocumentsModule.DocumentsGetter
  private document: DocumentInterface;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentTitle: string;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentId: string;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentDivisionOfTopics: boolean;
  @storeHelper.DocumentsModule.DocumentsGetter
  private voteOnDocument: boolean;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentPros: uid[];
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentCons: uid[];
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentProsConditional: uid[];
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentConditionalSupport: boolean;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentEditors;
  @storeHelper.DocumentsModule.DocumentsGetter
  private documentTopics;
  @storeHelper.DocumentsModule.DocumentsAction
  private updateDocument;

  @storeHelper.UsersModule.UsersGetter
  private isSignedIn: boolean;
  @storeHelper.UsersModule.UsersGetter
  private isNewUser: boolean;
  @storeHelper.UsersModule.UsersGetter
  private user: MiniUserInterface;
  @storeHelper.UsersModule.UsersAction
  private signIn;
  @storeHelper.UsersModule.UsersAction
  private checkUserProperties;

  @storeHelper.RouterModule.RouterGetter
  private getPath: (object) => string;
  @storeHelper.RouterModule.RouterGetter
  private currentRoute;
  @storeHelper.RouterModule.RouterMutation
  private setTransitionName;
  @storeHelper.RouterModule.RouterAction
  private pushWithParams;
  @storeHelper.RouterModule.RouterAction
  private push;

  @storeHelper.DisplayModule.DisplayMutation
  private setNavBar;
  @storeHelper.DisplayModule.DisplayGetter
  private getColor;

  @storeHelper.SectionsModule.SectionsGetter
  public allSections: ParentSectionInterface[];
  @storeHelper.SectionsModule.SectionsGetter
  private sectionsByStatus: (number, string) => ParentSectionInterface[];
  @storeHelper.SectionsModule.SectionsGetter
  private sectionById;
  @storeHelper.SectionsModule.SectionsGetter
  private initialParentId: string;
  @storeHelper.SectionsModule.SectionsAction
  private updateSection;
  @storeHelper.SectionsModule.SectionsAction
  private addSection;
  @storeHelper.SectionsModule.SectionsGetter
  private sectionsByTopics;
  @storeHelper.SectionsModule.SectionsGetter
  private sectionsByTopicsAndStatuses: SectionInterface[];

  @storeHelper.MainModule.MainGetter
  private isLoading: boolean;
  @storeHelper.MainModule.MainGetter
  private infoVideo: string;

  @storeHelper.VotingModule.VotingAction private addVote: (
    {
      // type: string;
      // object: SectionInterface | DocumentInterface,
      // vote: enums.VOTING_OPTIONS;
    },
  ) => VotesInterface;
  @storeHelper.VotingModule.VotingGetter
  private isUserVoted: boolean;
  @storeHelper.VotingModule.VotingAction
  private updateParentSectionByStatus;
  @storeHelper.SectionsModule.SectionsAction
  private getSizeByStatus: (number) => number;

  private dialog: boolean = true;
  private enums = enums;
  private isEdit = {};
  private newTopic: string = '';
  private newSectionContentHtml: string = '';
  private newSectionContent: string = '';
  private dragOptions = {
    animation: 200,
    group: "description",
    disabled: false,
    ghostClass: "ghost"
  };
  private drag = false;
  private loading = false;
  private approvedSize: number = 0;

  private async mounted() {
    const navBarPref: NavBarInterface = {
      title: 'טיוטת המסמך',
      icon: NAVBAR_SIDE_ICON.menu,
      color: this.getColor(enums.SECTION_STATUS.inTheVote),
    };
    this.setNavBar(navBarPref);
    this.setTransitionName('slide-right');
    this.getSizes();
    if ('vote' in this.$route.query) {
      const vote = this.$route.query.vote;
      if (vote === 'pros' || vote === 'cons') {
        this.addVoteToDocument(vote);
      }
    }
  }

  get isUserEditor() {
    return this.isSignedIn && this.documentEditors ?
        this.user.notifications && this.documentEditors.includes(this.user.notifications.mailAddress) : false;
  }

  get sections() {
    const parentSectionInterfaces = this.sectionsByStatus(enums.SECTION_STATUS.approved, this.initialParentId);
    //console.log('Draft.ts Get Sections, Parent Section Interfaces: ', parentSectionInterfaces);
    const sections: ParentSectionInterface[] = parentSectionInterfaces;
    if (this.documentDivisionOfTopics) {
      let sorted0 = this.sortByFirstVersionCreatedAt(sections);
      const sortedSections = this.sortByTopics(sorted0);
      console.log('Draft.ts Sorted Sections: ', sortedSections);
      this.isEdit = {};
      Object.keys(sortedSections).forEach(topic => this.isEdit[topic] = false);
      Object.values(sortedSections).forEach(arr=> {
        //@ts-ignore
        arr.forEach(section => this.isEdit[section.id] = false)
      })
      return sortedSections;
    } else {
      const sortedSections = this.sortByFirstVersionCreatedAt(sections).map((section, index) => {
        Object.assign(section, {index: index + 1})
      });
      console.log('Draft.ts Sorted Sections (Null): ' + sortedSections);
      return {
        null: sortedSections,
      };
    }
  }

  public async getSizes() {
    const approved = await this.getSizeByStatus(enums.SECTION_STATUS.approved);
    const edited = await this.getSizeByStatus(enums.SECTION_STATUS.edited);
    this.approvedSize = approved + edited;
    console.log('Draft.ts approvedSize = ' + this.approvedSize);
  }

  /**
   * sort the sections by createdAt of the first version:
   * if section has edited array, take the id and find the timesamp of the first version. if not -> take the timestamp of the section
   * @param {SectionInterface[]} sections status of the section
   *
   */
  private sortByFirstVersionCreatedAt(sections: ParentSectionInterface[]) {
    let sectionsByTimestamp: any[] = [];
    sections.map((section) => {
      if (section.edited && section.edited.length > 0) {
        // take the first version createdAt timestamp
        const id = section.edited[0];
        console.log("createdAt:::::", id, this.allSections, this.allSections[id])
        if (this.allSections[id]) {
          sectionsByTimestamp.push({
            timestamp: this.allSections[id].createdAt,
            section,
          });
        }
      } else {
        sectionsByTimestamp.push({
          timestamp: section.createdAt,
          section,
        });
      }
    });
    sectionsByTimestamp = sectionsByTimestamp.sort((sectionA, sectionB) =>
    new Date(sectionA.timestamp).getTime() - new Date(sectionB.timestamp).getTime()).map((section) => section.section);
    sectionsByTimestamp.sort((sectionA, sectionB) => {
      if (!sectionA.sectionOrder) {
        return 1;
      } else if (!sectionB.sectionOrder) {
        return -1;
      } else {
        return sectionA.sectionOrder - sectionB.sectionOrder
      }
    });
    return sectionsByTimestamp;
  }

  private sortByTopics(sections) {
    const sectionsByTopics = {};
    if (sections.length === 0) { return {}; }
    sections.forEach((section) => {
      let topic = section.topic;
      if (!sectionsByTopics[topic]) {
        sectionsByTopics[topic] = [];
      }
      sectionsByTopics[topic].push(section);
    });
    return this.orderTopics(sectionsByTopics);
  }

  private orderTopics(sectionsByTopics) {
    const sectionsByTopicsWithOrder = {};
    sectionsByTopics['מבוא'] ? (sectionsByTopicsWithOrder['מבוא'] = sectionsByTopics['מבוא']) : null;
    Object.keys(sectionsByTopics).sort().forEach((topic) => {
      if (topic !== 'מבוא' && topic !== 'סיכום') { sectionsByTopicsWithOrder[topic] = sectionsByTopics[topic]; }
    });
    sectionsByTopics['סיכום'] ? (sectionsByTopicsWithOrder['סיכום'] = sectionsByTopics['סיכום']) : null;
    let index = 0;
    Object.keys(sectionsByTopicsWithOrder).forEach((key) => {
      sectionsByTopicsWithOrder[key] = sectionsByTopicsWithOrder[key].map((section) => {
        index++;
        return Object.assign(section, { index });
      });
    });
    return sectionsByTopicsWithOrder;
  }

  //
  /**
   * check if section (parent) have status "toEdit" / "toDelete"
   * @param {SectionInterface} section
   * @param {number} status
   *
   */
  private isSectionHaveStatus(section: SectionInterface, status: number) {
    return section[Object.keys(enums.SECTION_STATUS)[status]] && section[Object.keys(enums.SECTION_STATUS)[status]].length > 0;
  }

  private voteOnNewSections(): void {
    const navbar = { path: this.currentRoute.fullPath };
    console.log('Draft.ts Set navbar ' + JSON.stringify(navbar));
    this.setNavBar(navbar);
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        sectionsByStatus: enums.SECTION_STATUS.inTheVote,
      },
    });
    console.log('Draft.ts Push path ' + path);
    this.push({ path });
  }

  /**
   * navigate to section page
   * @param {number} index the index of the section
   * @param {SectionInterface} section
   * @param {number} status
   *
   */
  private async navigateToSectionPage(index: number, status: number, section: SectionInterface) {
    const path = this.getPath({
      name: enums.ROUTE_NAME.section,
      params: {
        [enums.SECTION_BY.sectionsByStatus]: status,
        index: index + 1,
        id: section.id,
      },
    });
    this.setNavBar({ path: this.currentRoute.fullPath });
    this.push({ path });
  }

  /**
   * revision section (route to Add new page)
   * @param {SectionInterface} section
   * @param {number} nextStatus - toEdit / toDelete
   * @param {number} index
   *
   */
  private async navigateToAddNewPage(section: SectionInterface, nextStatus: number, index: number) {
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      await this.checkUserProperties();
      this.pushWithParams({
        name: enums.ROUTE_NAME.addNew,
        params: {
          type: 'section',
          action: nextStatus,
          sectionId: section.id!,
          parentSectionId: section.id!,
          status: section.status,
        },
      });
    }
  }

  private async addVoteToDocument(vote) {
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      await this.checkUserProperties();
      this.addVote({ type: 'document', object: this.document, vote });
    }
  }

  private goToChoose(): void {
    this.$router.push({name: enums.ROUTE_NAME.chooseTopics})
  }

  private goToVote(topic): void {
    localStorage.setItem('checkedList', topic);
    this.$router.push({name: enums.ROUTE_NAME.vote, params: { index: '1', statuses: `${enums.SECTION_STATUS.inTheVote},${enums.SECTION_STATUS.toEdit},${enums.SECTION_STATUS.toEditInTheVote}`}});
  }
  /**
   * adds new section
   */
  private async addNewSection() {
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      this.checkUserProperties();
      const pushToParams = {
        type: 'section',
        action: enums.SECTION_STATUS.inTheVote,
        sectionId: 0,
        parentSectionId: '0',
      };
      this.pushWithParams({ name: enums.ROUTE_NAME.addNew, params: pushToParams });
    }
  }
  private onClickBack() {
    history.go(-1);
  }
  private clearEdit() {
    Object.keys(this.isEdit).forEach(key => {
      this.isEdit[key] = false;
    });
  }
  private editTopic(topic) {
    this.clearEdit();
    this.isEdit[topic] = true;
    this.newTopic = topic;
    this.$forceUpdate();
  }
  private saveTopic(topic) {
    if (topic !== this.newTopic) {
      this.sectionsByTopics([topic]).forEach(section => {
        this.updateSection({
          id: section.id,
          updateObject: {
            topic: this.newTopic
          }
        });
      });
      const documentTopics = this.documentTopics.slice();
      const index = documentTopics.indexOf(topic);
      if (index !== -1) {
        documentTopics[index] = this.newTopic;
      }
      this.updateDocument({
        updateObject: {
          documentTopics
        }
      });
    }
    this.isEdit[topic] = false;
    this.$forceUpdate();
  }
  private contentChange({html, text}) {
    this.newSectionContentHtml = html;
    this.newSectionContent = text;
  }
  private editSection(section) {
    this.clearEdit();
    this.isEdit[section.id] = true;
    this.newSectionContentHtml = section.contentHtml || section.content;
    this.newSectionContent = section.content;
    this.$forceUpdate();
  }
  private async saveSection(section) {
    this.loading = true;
    this.isEdit[section.id] = false;
    const newSectionId: string = await this.addSection({
      content: this.newSectionContent,
      contentHtml: this.newSectionContentHtml,
      topic: section.topic,
      parentSectionId: section.id,
      toEdit: [],
      sectionOrder: section.sectionOrder || null,
      status: SECTION_STATUS.toEditInTheVote,
      acceptedAt: new Date(),
      acceptedByEditor: this.user.id
    });
    const newSection = this.sectionById(newSectionId)[0];
    await this.updateParentSectionByStatus({section: newSection, parentSectionId: section.id});
    await this.updateSection({
      id: newSectionId,
      updateObject: {
        parentSectionId: '0',
        status: SECTION_STATUS.approved
      }
    });
    await this.updateSection({
      id: section.id,
      updateObject: {
        status: SECTION_STATUS.edited
      }
    });
    this.$forceUpdate();
    this.loading = false;
  }
  private changeOrder(evt, topic, sections){
    if (evt.added) {
      this.updateSection({
        id: evt.added.element.id,
        updateObject: {
          topic: topic
        }
      });
    }
    const sectionsByTopics = Object.assign({}, sections);
    let sectionOrder = 0;
    Object.keys(sectionsByTopics).forEach(topic => {
      sectionOrder = 0;
      sectionsByTopics[topic].forEach(section => {
        sectionOrder++;
        if (section.sectionOrder !== sectionOrder) {
          this.updateSection({
            id: section.id,
            updateObject: {
              sectionOrder: sectionOrder
            }
          });
        }
      });
    });
  }
}
